import type { CSSProperties, ReactNode } from 'react';
import type { RecurrenceField } from './recurrenceFields';

const P: CSSProperties = { margin: 0 };

export const RECURRENCE_HELP: Record<RecurrenceField | 'freq' | 'tzid' | 'hour', ReactNode> = {
  freq: (
    <div>
      <p style={P}>YEARLY, MONTHLY, WEEKLY, DAILY – type of recurrence to use:</p>
      <p style={P}>(i.e. is the event every year, every month, weekly, or daily)</p>
    </div>
  ),
  tzid: (
    <div>
      <p style={P}>Time zone to apply the recurrence rule in.</p>
      <p style={P}>
        For example an hourly recurrence at 9 AM, will mean 9 AM in the specified time zone.
      </p>
    </div>
  ),
  hour: (
    <div>
      <p style={P}>Sets the reccurence hour value for the day.</p>
      <p style={P}>Valid values are 0 to 23.</p>
      <p style={P}>For example, an hourly recurrence at 9 AM can be represented as:</p>
      <p style={P}>RRULE:FREQ=DAILY;BYHOUR=9</p>
      <p style={P}>This defines the specific hour when the recurrence rule applies.</p>
    </div>
  ),
  weekday: (
    <div>
      <p style={P}>When given, these variables will define the weekdays</p>
      <p style={P}>where the recurrence will be applied.</p>
    </div>
  ),
  month: (
    <div>
      <p style={P}>Meaning the months to apply the recurrence to.</p>
    </div>
  ),
  setpos: (
    <div>
      <p style={P}>Comma-separated list of values. Valid values are 1 to 366 or -366 to -1.</p>
      <p style={P}>Each BYSETPOS value corresponds to the nth occurrence within the</p>
      <p style={P}>set of events specified by the rule.</p>
      <p style={P}>It MUST only be used in conjunction with another BYxxx rule part.</p>
      <p style={P}>For example the last work day of the month could be represented as:</p>
      <p style={P}>RRULE:FREQ=MONTHLY;BYDAY=MO,TU,WE,TH,FR;BYSETPOS=-1</p>
    </div>
  ),
  week_number: (
    <div>
      <p style={P}>Comma-separated list of ordinals specifying weeks of the year.</p>
      <p style={P}>Valid values are 1 to 53 or -53 to -1.</p>
      <p style={P}>This corresponds to weeks according to week numbering</p>
      <p style={P}>as defined in [ISO.8601.2004].</p>
    </div>
  ),
  month_day: (
    <div>
      <p style={P}>Comma-separated list of days of the month.</p>
      <p style={P}>Valid values are 1 to 31 or -31 to -1.</p>
      <p style={P}>For example, -10 represents the tenth to the last day of the month.</p>
    </div>
  ),
  year_day: (
    <div>
      <p style={P}>Comma-separated list of days of the year.</p>
      <p style={P}>Valid values are 1 to 366 or -366 to -1.</p>
      <p style={P}>For example, -1 represents the last day of the year (December 31st)</p>
      <p style={P}>and -306 represents the 306th to the last day of the year (March 1st).</p>
    </div>
  ),
};
